<template>
  <div>
    <div class="row pt-3 l-m-b-20">
      <div class="col-9">
        <h1>Carriers</h1>
      </div>
      <div class="col-3 text-right">
        <button class="btn btn-primary" @click="showCreateSidebar = !showCreateSidebar">
          ADD CARRIER
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 l-m-b-20">
        <div class="input-group search">
          <input class="form-control" type="text" v-model="q" @keyup="searchText($event)" placeholder="Search" />
          <button type="button" class="btn input-group-btn" @click="clearSearch">
            <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
          </button>
        </div>
      </div>
      <div class="col-12 filters-field" />
    </div>
    <template v-if="!carriers">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <table class="table m-table table-hover l-m-t-20">
        <thead class="m-table__heading">
          <tr>
            <th class="m-table__id">ID</th>
            <th @click="sortBy('name')" :class="{ active: sortKey === 'name' }" class="sortable">
              Name
              <span class="arrow" :class="sortOrders['name'] ? 'dsc' : 'asc'" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="carrier in carriers"
              @mouseup="$_can('carriers.show') && view($event, carrier.id)"
              class="pointer"
              :key="carrier.id"
          >
            <td>
              {{ carrier.id }}
            </td>
            <td>
              {{ carrier.name }}
            </td>
          </tr>
          <tr v-if="carriers && !carriers.length">
            <td colspan="3" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <div class="row blocks">
      <div class="col-md-6 mb-1 text-black-50"
           v-if="meta && meta.total"
      >
        Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
      </div>
      <pagination class="col-md-6 mb-1" :change-page="changePage" :meta="meta" />
    </div>

    <!-- Create Carrier -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showCreateSidebar" @click.self="showCreateSidebar = false">
        <carriers-create class="sidebar-right" @cancel="showCreateSidebar = false"
                         @update="getAllCarriers"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import Pagination from '../Pagination';
import CarriersCreate from './CarriersCreate';

export default {
  components: {
    CarriersCreate,
    Pagination,
  },
  data: () => ({
    page: 1,
    q: '',
    sortKey: '',
    sortOrders: [],
    showCreateSidebar: false,
  }),
  computed: {
    ...mapState({
      carriers: state => state.carriers.paginatedCarriers.data,
      meta: state => state.carriers.paginatedCarriers.meta,
    }),
    ...mapGetters(['getCarriersSearched']),
  },
  created() {
    this.getPaginatedCarriers();
  },
  methods: {
    ...mapMutations(['setPaginatedCarriers']),
    ...mapActions(['getPaginatedCarriers', 'getCarriers']),
    view(event, id) {
      if (event.button === 1) {
        window.open(this.$router.resolve(`/carriers/edit/${id}`).href, '_blank');
      } else {
        this.$router.push(`/carriers/edit/${id}`);
      }
    },
    changePage(pageNum) {
      this.page = pageNum;
      this.filter();
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    filter() {
      this.getCarriersSearched(
        this.page,
        this.q,
        this.sortKey,
        this.sortOrders[this.sortKey] ? 'asc' : 'desc',
      );
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    sortBy(key) {
      this.sortKey = key;
      this.$set(this.sortOrders, key, !this.sortOrders[key]);
      this.filter();
    },
    getAllCarriers() {
      this.setPaginatedCarriers({});
      this.getPaginatedCarriers();
      this.getCarriers();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/carriers/Carriers.vue